import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, lastValueFrom } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { BankData, OcrResponse } from '../../interfaces/ui/ocr.interface';
import { DEFAULT_ATTEMPS } from '../../constants/constants';

@Injectable({
  providedIn: 'root',
})
export class OcrService {
  private readonly URL = `${environment.API_URL}/ocr/process-receipt`;

  constructor(private http: HttpClient) {}

  extractData(file: File, attempt = DEFAULT_ATTEMPS): Observable<OcrResponse> {
    const formData = new FormData();
    formData.append('receipt', file);
    formData.append(
      'attempt',
      String(Math.max(DEFAULT_ATTEMPS, Number(attempt) || DEFAULT_ATTEMPS)),
    );

    return this.http.post<OcrResponse>(this.URL, formData);
  }

  async extractDataAsync(
    file: File,
    attempt = DEFAULT_ATTEMPS,
  ): Promise<BankData | null> {
    const response = await lastValueFrom(this.extractData(file, attempt));
    return response?.data ?? null;
  }

  getActiveProvider(): Observable<{ data: { provider: 'gemini' | 'ollama' } }> {
    return this.http.get<{ data: { provider: 'gemini' | 'ollama' } }>(
      `${environment.API_URL}/ocr/active-provider`,
    );
  }
}
